import { context, propagation, trace, Span } from '@opentelemetry/api';
import { appName } from '../constants/setup';
import { TraceCarrier } from '../types/setup';

const tracer = () => trace.getTracer(`${appName}-tracer`);

// Set trace carrier to current context
const getTraceContext = (traceCarrier?: TraceCarrier) => {
  if (!traceCarrier) return;
  return propagation.extract(context.active(), traceCarrier);
};

// Get trace carrier from current context
const getTraceCarrier = (span?: Span) => {
  const carrier: TraceCarrier = {};
  const spanContext = span ? trace.setSpan(context.active(), span) : context.active();
  propagation.inject(spanContext, carrier);
  return carrier;
};

export { tracer, getTraceContext, getTraceCarrier };
